import ReactHtmlParser from "react-html-parser";

export default (sopParameters) => ReactHtmlParser(
  `<div>
  <h2>SSD Linehaul Dwelling Induct</h2>
  <h3>Description</h3>
  <p>This disruption occurs when an outbound SSD truck has already been docked within the TDR process, but package induction has not finished.</p>
  <h3>SOP</h3>
  <ul>
    <li><b>At Risk:</b> This proactive signal is to alert the site that &gt;50% of the volume remains to be inducted within the last hour.</li>
    <li><b>Critical:</b> This signal is to alert the site that &gt;25% of the volume remains to be inducted within the last 30 minutes.</li>
    <li><b>Late:</b> This signal is to alert the site that &gt;10% of the volume remains. Remaining packages are now injection late induct.</li>
  </ul>
  <div>
    For all alert severities, continue inducting packages from the VRID in order to resolve this alert.
  </div>
</div>`
);



// WEBPACK FOOTER //
// ./src/components/taskExecution/TaskSOP/FallbackSOPWiki/SSD_LINEHAUL_DWELLING_INDUCT.jsx